// @flow
import * as React from 'react';
import { connect } from 'react-redux';

import type { MapStateToProps } from 'react-redux';

import { EVENT_VIEW } from '../calendar.consts.js';

type OwnProps = {||};

type MappedState = {|
  UI: UI,
  URL: URL,
  event: event
|};

type Props = {|
  ...OwnProps,
  ...MappedState
|};

class EventContainer extends React.Component<Props> {
  render() {
    const { UI, URL, event } = this.props;

    return (
      <div className="event-container">
        {UI.progress ? (
          <span>
            <span className="loading-icon icon tools active" />
            <div className="loading-opacity active" />
          </span>
        ) : null}
        {URL.eventParams.action === EVENT_VIEW &&
        (event.wrongPilots == '1' || event.wrongResources == '1') ? (
          <div className="event-view-message alert alert-warning">
            {event.wrongPilots == '1' ? (
              <div>
                Organization {event.organizationName} does not have such pilot or SIC pilot.
              </div>
            ) : (
              <div>
                Organization {event.organizationName} no longer has one of the selected resources.
              </div>
            )}
          </div>
        ) : null}
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  UI: state.UI,
  URL: state.URL,
  event: state.event
});

export default connect(
  mapStateToProps,
  {}
)(EventContainer);
